const isDev = process.env.NODE_ENV !== "production";

const getUrlWithApiPrefix = (url: string) =>
  isDev ? `http://localhost:4000${url}` : url;

export default getUrlWithApiPrefix;
